module.exports = __webpack_public_path__ + "static/media/cancel_btn.950f3f4a.svg";